export default "__VITE_ASSET__CiB1IBgH__ 400w, __VITE_ASSET__DN695ON4__ 800w, __VITE_ASSET__BR8NcSjz__ 1200w";